import React from "react";

import FaqsRoute from "../../features/faqs/FaqsRoute";

const Faqs = () => (
  <div className="faqs-page full-bleed">
    <FaqsRoute />
  </div>
);

export default Faqs;
